module.exports = __webpack_public_path__ + "img/serious.1e5203d9.png";